<template>
  <div id="app">
    <span v-if="isGood">Processing...</span>
    <span v-if="isError">{{isError}}</span>
    <redirect-post-form v-if="responseRedirect" :response="responseRedirect"/>
    <form class="" id="challengeForm">
      <input type="hidden"
             name="threeDSMethodData"
             id="threeDSMethodData"/>
    </form>
  </div>
</template>

<script>
import { PaymentService } from './services/payment';
import RedirectPostForm from './components/RedirectPostForm.vue';

export const STATE = {
  OFFER: 'offer',
  RESULT: 'result',
  REDIRECT: 'redirect',
  IN_PROGRESS: 'in_progress',
  AUTHENTICATION: 'authentication',
  THREEDS2PREPARE: '3ds2_prepare',
  IFRAME: 'iframe',
};

export default {
  name: 'App',
  components: { RedirectPostForm },
  data() {
    return {
      responseRedirect: null,
      hiddenIframe: null,
      isGood: true,
      isError: false,
      response: null,
      hiddenFrameWasExist: false,
      lastExecutionTime: parseInt(Date.now()/1000),
      isStopCheckState: false,
      isWasReloaded: false,
    };
  },
  methods: {
    async createHiddenIframe(response) {
      let displayBox = document.getElementById('app');
      let iframe = document.createElement('iframe');
      iframe.name = "challengeIframe";
      iframe.display = 'none';
      displayBox.appendChild(iframe);
      let form = document.getElementById('challengeForm');
      if(response.post) {
        document.getElementById('threeDSMethodData').value = response.post.threeDSMethodData;
        form.method = 'post';
      } else {
        form.method = 'get';
      }

      form.action = response.url;
      form.target = 'challengeIframe';
      iframe.appendChild(form);
      form.submit();
      this.hiddenFrameWasExist = true;
      this.hiddenIframe = true;
    },
    async checkStatePayment(response, token, portal) {
      const { state } = response;
      switch (state) {
        case STATE.IN_PROGRESS:
          PaymentService.stateToken(token, portal)
                  .then(async (response) => {
                    await this.checkStatePayment(response, token, portal);
                  // eslint-disable-next-line
                  }).catch((e) => {
          });
          break;
        case STATE.THREEDS2PREPARE:
          PaymentService.threedsV2prepare(token, portal)
                  .then(async (response) => {
                    await this.checkStatePayment(response, token, portal);
                  });
          break;
        case STATE.IFRAME:
          this.response = response;
          if(response.iframeMode === 'SIZED') {
            const url = new URL(window.location.href);
            url.searchParams.set('reload', true);
            window.history.replaceState(null, null, url);
            window.location.reload();
          }
          if(response.iframeMode === 'HIDDEN' && !this.hiddenFrameWasExist) {
            await this.createHiddenIframe(response);
            setInterval(async () => {
              const resp = await PaymentService.stateToken(this.token, this.portal);
              if(resp.iframeMode === 'SIZED') {
                const url = new URL(window.location.href);
                url.searchParams.set('reload', true);
                window.history.replaceState(null, null, url);
                window.location.reload();
              }
              else if(resp.state === STATE.REDIRECT) {
                window.location.href = resp.url;
              }
            }, 2000);
          }
          if (response.post && response.iframeMode === 'SIZED' && !this.isStopCheckState) {
            if(this.isWasReloaded) {
              this.isStopCheckState = true;
              this.responseRedirect = response;
            }
          }
          break;
        case STATE.REDIRECT:
          window.scrollTo(0, 0);
          if (response.post) {
            this.responseRedirect = response;
          } else {
            window.location.href = response.url;
          }
          break;
      }
    },
  },
  async created() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    this.token = urlParams.get('token');
    this.portal = urlParams.get('portal');
    this.isWasReloaded = !!urlParams.get('reload');
    if(window.settings.isDebug === true) {
      let resp = await PaymentService.getToken(this.portal);
      this.token = urlParams.get('token') || resp.token;
      const url = new URL(window.location.href);
      url.searchParams.set('token', this.token);
      window.history.replaceState(null, null, url);
      const params = {
        amount: 10000,
        commission: 1000,
        currency: 'RUB',
        'dst.addToProfile': false,
        'dst.pan': '2203000000000076',
        'dst.type': 'card',
        'params.quoteCurrency': 'RUB',
        'params.rublRateSell': '0.1',
        'params.transferAmount': 100000,
        'returnUrl': `https://widget3-api.intervale.ru/bill/${this.token}?portal_id=P2PTKBWEB00000000000000000000001`,
        'src.addToProfile': false,
        'src.csc': '123',
        'src.expiry': '0624',
        'src.pan': '2203000000000068',
        'src.type': 'card'
      };
      if(!this.isWasReloaded) {
        await PaymentService.start(this.token, params, this.portal);
      }
    }
    if( !this.token ) {
      this.isGood = false;
      this.isError = 'Parameter token is required';
      return;
    }
    if( !this.portal ) {
      this.isGood = false;
      this.isError = 'Parameter portal is required';
      return;
    }
    try {
      PaymentService.stateToken(this.token, this.portal)
              .then(async (response) => {
                await this.checkStatePayment(response, this.token, this.portal);
              // eslint-disable-next-line
              }).catch((e) => {
                this.isGood = false;
                this.isError = e.data.error;
      });
    } catch (e) {
      console.log(e);
      this.isGood = false;
      this.isError = e.data.error;
    }

  }
}
</script>
<style>
  iframe {
    visibility: hidden;
    height: 0;
  }
</style>
